import type { APIClient } from "@heidelbergmaterials/fcl-apiclient"

import type { SupportedLanguage } from "./types"

export type { SupportedLanguage } from "./types"

export const getSupportedLanguages = (
	apiClient: APIClient,
): Promise<SupportedLanguage[]> =>
	apiClient.get("/languages").then(response => response.data)

export const toggleSupportedLanguage = (
	apiClient: APIClient,
	languageCode: string,
	active: boolean,
): Promise<void> =>
	apiClient
		.patch(`/languages/${languageCode}`, { active })
		.then(response => response.data)
